import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import deprecated from '../../utils/deprecated'

/*
 * Bronson FoldOut component.
 *
 * Generated React component.
 */
export function FoldOut({
  productInfoSummary,
  defaultOpen = false,
  children,
  /**
   * @deprecated Remove in Bronson-React v6.0.0.
   * Replaced by productInfoSummary, for <7.5.0
   */
  headerImageSrc,
  headerImageAlt,
  title,
  subtitle,
  info,
  bronson700CompatibilityForArrow,
  // ---
  testId,
  ...otherProps
}) {
  const [open, setOpen] = useState(defaultOpen)

  useEffect(() => {
    setOpen(defaultOpen)
  }, [defaultOpen])

  function toggleOpen() {
    setOpen(!open)
  }

  /**
   * @deprecated Remove in Bronson-React v6.0.0.
   * @returns {JSX.Element|null}
   */
  function renderIfFoldOutHeaderImageSrc() {
    if (headerImageSrc) {
      return (
        <span className="c-fold-out__img">
          <img src={headerImageSrc} alt={headerImageAlt} />
        </span>
      )
    }
    return null
  }

  /**
   * @deprecated Remove in Bronson-React v6.0.0.
   * @returns {JSX.Element|null}
   */
  function renderIfFoldOutSubtitle() {
    if (subtitle) {
      return <span className="c-fold-out__subtitle">{subtitle}</span>
    }
    return null
  }

  function renderIfProductInfoSummary() {
    if (productInfoSummary) {
      return <>{productInfoSummary}</>
    }
    return null
  }

  /**
   * @deprecated Remove in Bronson-React v6.0.0.
   * @returns {JSX.Element|null}
   */
  function renderIfNotProductInfoSummary700() {
    if (!productInfoSummary) {
      return (
        <>
          {renderIfFoldOutHeaderImageSrc()}
          <span className="c-fold-out__heading">
            <span className="c-fold-out__title">{title}</span>
            {renderIfFoldOutSubtitle()}
          </span>
          <span className="c-fold-out__info">{info}</span>
        </>
      )
    }
    return null
  }

  // generated main result
  return (
    <div {...otherProps} data-testid={testId} className="c-fold-out js-fold-out js-is-ready">
      <button
        className="c-fold-out__header js-fold-out__toggle"
        type="button"
        aria-expanded={open}
        onClick={() => toggleOpen()}
      >
        {renderIfProductInfoSummary()}
        {/* @deprecated Remove in Bronson-React v6.0.0. */}
        {renderIfNotProductInfoSummary700()}

        {bronson700CompatibilityForArrow && <i className="c-fold-out__icon" aria-hidden="true" />}
      </button>
      {/**
       * Need to pass `[inert=""]` as React currently does not support HTMLElement.inert mapping.
       * @see https://github.com/facebook/react/pull/24730
       * @TODO: Remove once React supports direct `[inert]` usage.
       */}
      <div className="c-fold-out__content js-fold-out__content" aria-hidden={!open} inert={open ? null : ''}>
        {children}
      </div>
      {/* @TODO: Align with Bronson regarding `[aria-label]`. */}
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className="c-fold-out__footer js-fold-out__toggle"
        type="button"
        aria-expanded={open}
        onClick={() => toggleOpen()}
      />
    </div>
  )
}

FoldOut.propTypes = {
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  productInfoSummary: PropTypes.node,
  testId: PropTypes.string, // Added for data-testid attribute.
  // replaced by productInfoSummary, for <7.5.0
  headerImageSrc: deprecated(
    PropTypes.string,
    'Removed in Bronson v7.5.0. Please use `productInfoSummary` instead. Will be removed in Bronson-React v6.0.0.'
  ), // Bronson template: 'fold-out-header-img'.
  headerImageAlt: deprecated(
    PropTypes.string,
    'Removed in Bronson v7.5.0. Please use `productInfoSummary` instead. Will be removed in Bronson-React v6.0.0.'
  ),
  title: deprecated(
    PropTypes.node,
    'Removed in Bronson v7.5.0. Please use `productInfoSummary` instead. Will be removed in Bronson-React v6.0.0.'
  ), // Bronson template: 'fold-out-title'.
  subtitle: deprecated(
    PropTypes.node,
    'Removed in Bronson v7.5.0. Please use `productInfoSummary` instead. Will be removed in Bronson-React v6.0.0.'
  ), // Bronson template: 'fold-out-subtitle'.
  info: deprecated(
    PropTypes.node,
    'Removed in Bronson v7.5.0. Please use `productInfoSummary` instead. Will be removed in Bronson-React v6.0.0.'
  ), // Bronson template: 'fold-out-info'.
  bronson700CompatibilityForArrow: deprecated(
    PropTypes.bool,
    'Removed in Bronson v7.5.0. Please use `productInfoSummary` instead. Will be removed in Bronson-React v6.0.0.'
  ),
}
